export default {
  'NEW': {
    style: 'primary',
    outline: true,
    text: {
      pl: 'Nowe',
      en: 'New'
    }
  },
  'IN_PROGRESS': {
    style: 'warning',
    outline: true,
    text: {
      pl: 'Trwające',
      en: 'In progress'
    }
  },
  'SENT_TO_SETTLEMENT': {
    style: 'success',
    outline: true,
    text: {
      pl: 'Wysłano do rozliczenia',
      en: 'Sent to settlement'
    }
  },
  'DONE': {
    style: 'success',
    outline: false,
    text: {
      pl: 'Ukończone',
      en: 'Finished'
    }
  }
}
